module.exports = __webpack_public_path__ + "img/scheme-once.aaa2fbed.jpg";